/**
 * created by xcc
 单位选择
 *
 */
import React from 'react';
import BaseComponent from "../../../../../../base/BaseComponent";
import {generateTreeData} from "../../../../../../utils";

export default class UnitSelect extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            treeData: [],
            path: "",
            treeDataIndex: {
                id: "id",
                title: "name",
                children: "child",
                key: "id"
            },
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.deptGetTree();
    }

    updatePath() {
        let {treeData} = this.state;
        let {value} = this.props;
        const path = this.findPathToNode(treeData, value);
        if (path) {
            const pathNames = path.map((node, index) => {
                const depth = path.findIndex(p => p.id === node.id);
                return '  '.repeat(depth) + node.title;
            }).join(' / ');
            this.setState({path: pathNames});
        }
    }

    deptGetTree = () => {
        this.deptGetTreeRequest(res => {
            // 格式化树数据
            const treeData = generateTreeData(res.child, this.state.treeDataIndex);
            this.setState({
                treeData
            }, () => {
                this.updatePath()
            });
        });
    };
    deptGetTreeRequest = (callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/getTree",
            body: {id: 0},
            callBack
        });
    };

    findPathToNode(nodes, targetId, path = []) {
        for (let node of nodes) {
            if (node.id === targetId) {
                path.push(node);
                return path;
            }
            if (node.children) {
                const result = this.findPathToNode(node.children, targetId, [...path, node]);
                if (result) {
                    return result;
                }
            }
        }
        return null;
    }

    render() {
        let {path} = this.state;
        return (
            <div className={"position-manage-detail-value"}>
                {path}
            </div>
        )
    }
}